<template>
  <el-container class="CodeForm">
    <el-main class="p-0">
      <el-form :model="data" :rules="rules" ref="form" label-width="100px">
        <el-form-item :label="$t('lang.code_type')" prop="name" class="block">
          <el-col :span="8">
            <el-input
              :value="$t('lang.' + data.name)"
              maxlength="50"
              disabled
              class="block"
            />
          </el-col>
        </el-form-item>

        <el-form-item
          :label="$t('lang.code_rule')"
          prop="details"
          class="block"
        >
          <el-row v-for="(detail, index) in details" :key="detail.id">
            <el-col :span="8">
              <el-cascader
                :class="'block'"
                v-model="detail.type_length"
                :options="options"
                :props="{ expandTrigger: 'hover' }"
                @change="handleChange"
              />
            </el-col>

            <el-col
              :span="3"
              style="margin-left: 10px"
              v-if="
                detail.type === 'f' ||
                  (detail.type === 'y' && detail.length === 1)
              "
            >
              <el-input v-model="detail.text" maxlength="4" class="block" />
            </el-col>

            <el-button-group
              style="margin-left: 10px; vertical-align: text-bottom"
            >
              <el-button
                type="primary"
                icon="el-icon-plus"
                @click="addRule(index)"
              />
              <el-button
                type="danger"
                icon="el-icon-minus"
                @click="removeRule(index)"
              />
            </el-button-group>
          </el-row>
        </el-form-item>
      </el-form>
    </el-main>
    <el-footer height="40px">
      <el-button
        type="primary"
        v-shortkey="['f4']"
        :disabled="!has_grant_write"
        :loading="load_button"
        @shortkey.native="clickSave"
        @click="clickSave"
        >{{ $t("button.save") }} (F4)</el-button
      >
      <el-button class="close-button" @click="closeDialog"
        >{{ $t("button.close") }}(Esc)</el-button
      >
    </el-footer>
  </el-container>
</template>

<script>
import { form } from "@/common/mixins/form";

export default {
  name: "CodeForm",
  mixins: [form],
  data() {
    return {
      options: [
        {
          value: "f",
          label: "고정문자",
        },
        {
          value: "y",
          label: "연",
          children: [
            {
              value: 4,
              label: "4자리",
            },
            {
              value: 2,
              label: "2자리",
            },
            {
              value: 1,
              label: "알파벳",
            },
          ],
        },
        {
          value: "m",
          label: "월",
          children: [
            {
              value: 2,
              label: "2자리",
            },
            {
              value: 1,
              label: "1자리 알파벳",
            },
          ],
        },
        {
          value: "d",
          label: "일",
          children: [
            {
              value: 2,
              label: "2자리",
            },
          ],
        },
        {
          value: "s",
          label: "일련번호",
          children: [
            {
              value: 2,
              label: "2자리",
            },
            {
              value: 3,
              label: "3자리",
            },
            {
              value: 4,
              label: "4자리",
            },
            {
              value: 5,
              label: "5자리",
            },
            {
              value: 6,
              label: "6자리",
            },
          ],
        },
      ],
      detail: function() {
        return { code_id: this.data.id, type: "", length: null, text: null };
      },
      rules: {
        // name: [{required: true, message: '코드 구분을 입력해 주세요.', trigger: 'blur'}],
      },
      originData: null,
      load_button: false,
    };
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
    has_grant_write: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    /** 상세정보 */
    details: function() {
      let details = this.data.details;
      if (details.length > 0) {
        details.forEach((detail) => {
          detail.type_length = [];
          detail.type_length.push(detail.type);
          if (detail.type !== "f") detail.type_length.push(detail.length);
        });
      } else {
        details.push(
          Object.assign(
            {},
            { code_id: this.data.id, type: "", length: null, text: null }
          )
        );
      }
      return details;
    },
  },
  methods: {
    handleChange() {
      this.details.forEach((detail) => {
        if (detail.type_length.length > 0) {
          detail.type = detail.type_length[0];
          if (detail.type !== "f") detail.length = detail.type_length[1];
        }
      });
    },
    isValidType() {
      let hasEmpty = this.details.some((detail) => {
        if (!detail.type || detail.type === "") {
          return true;
        }
      });
      return !hasEmpty;
    },
    isValidText() {
      let hasEmpty = this.details.some((detail) => {
        if (detail.type === "f" && (!detail.text || detail.text === "")) {
          return true;
        }
      });
      return !hasEmpty;
    },
    /** 규칙 총 자릿수 */
    getTotalLength() {
      let length = 0;
      this.details.forEach((detail) => {
        if (detail.type === "f") {
          length += detail.text ? detail.text.length : 0;
        } else {
          length += detail.length;
        }
      });
      return length;
    },
    addRule(index) {
      this.details.splice(
        index + 1,
        0,
        Object.assign(
          {},
          {
            code_id: this.data.id,
            type: "",
            length: null,
            text: null,
          }
        )
      );
    },
    removeRule(index) {
      this.details.splice(index, 1);
    },
    /** 저장 */
    clickSave() {
      if (!this.has_grant_write) return;

      this.$refs.form.validate((valid) => {
        if (!valid) return;
        this.doSave();
      });
    },

    /** 데이터 값 정리 */
    organizeData() {
      let param = Object.assign({}, this.data);
      param.details.forEach((detail, index) => {
        detail.seq = index + 1;

        if (detail.type === "f") {
          detail.length = detail.text.length;
        }
      });

      return param;
    },
    doSave() {
      if (!this.isValidType()) {
        this.util.notify(
          this,
          "w",
          this.$t("lang.title_code"),
          "규칙을 선택하세요."
        );
        return;
      }

      if (!this.isValidText()) {
        this.util.notify(
          this,
          "w",
          this.$t("lang.title_code"),
          "고정문자를 입력하세요."
        );
        return;
      }

      const data = this.organizeData();

      if (this.getTotalLength() > 20) {
        this.util.notify(
          this,
          "w",
          this.$t("lang.title_code"),
          this.$t("message.warn_code_total_length")
        );
        return;
      }
      this.load_button = true;
      this.api.updateCode(data).then((res) => {
        this.load_button = false;
        if (res.error !== this.system.noError) {
          this.util.notify_error(this, this.$t("lang.title_code"), res.message);
          return;
        }
        this.handleResult(res, "save", "저장되었습니다.");
      });
    },

    /** 닫기 */
    handleResult(res, action, message) {
      if (res.error === this.system.noError) {
        const options = this.util.get_notify_options(
          "s",
          this.$t("lang.title_code"),
          message
        );
        this.$emit("completed", action, options);
        return;
      }
      this.util.notify_error(this, this.$t("lang.title_code"), res.message);
    },
  },
};
</script>

<style lang="scss" scoped>
.block {
  width: 100% !important;
}

.CodeForm {
  .el-main {
    height: auto;
  }
}
</style>
